import React, { Component, lazy, Suspense } from 'react';
import postal from 'postal';
import { string, object, bool } from 'prop-types';
import { Menu } from '@material-ui/icons';
import styles from './styles/styles.module.scss';
import { StringConstantsMixin } from '../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { wrapEventHandler } from '../../utils/handlers';
import { generateNavigationProps } from '../../utils/header_helper';

const SideDrawer = lazy(() => import('../SideDrawer'));

class NavigationDrawer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      slimMode: false,
      ...generateNavigationProps(props), // props passed in for state for logging in and out without a page refresh
      isMounted: false
    };
  }

  componentDidMount() {
    if (this.props.messagingChannel) {
      this.props.messagingChannel.subscribe('navigation.slim', this.toggleSlimNavigation);
      this.props.messagingChannel.subscribe('navigation.loginUser', this.updateForLoggedInUser);
    }
    this.setState({ isMounted: true });
  }

  componentWillUnmount() {
    // This check for "unsubscribe" prevents weird HMR issues
    if (this.props.messagingChannel && typeof this.props.messagingChannel.unsubscribe === 'function') {
      this.props.messagingChannel.unsubscribe('navigation.slim');
      this.props.messagingChannel.unsubscribe('navigation.loginUser');
    }
  }

  updateForLoggedInUser = data => {
    const loggedInState = generateNavigationProps(data);
    this.setState({ ...loggedInState });
  };

  toggleSlimNavigation = ({ slimMode }) => {
    this.setState({ slimMode });
  };

  toggleIsOpen = e => {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen }, this.toggleWindowLockAndTrack);
  };

  toggleWindowLockAndTrack() {
    this.trackSliderOpen();
    this.toggleWindowLock();
  }

  trackSliderOpen() {
    _gaq.push(['_trackEvent', 'Mobile Header', 'Toggle', window.location.pathname]);
  }

  toggleWindowLock() {
    this.state.isOpen
      ? document.querySelector('html').classList.add('mobile-screen-lock')
      : document.querySelector('html').classList.remove('mobile-screen-lock');
  }

  updateLinkRef(linkPath) {
    return linkPath.replace('?ref=header', '?ref=mobile-header');
  }

  updateDropdownLinkRef(link) {
    if (!link.dropdown) {
      return;
    }

    return link.dropdown.map(dropdownLink => {
      return { ...dropdownLink, linkPath: this.updateLinkRef(dropdownLink.linkPath) };
    });
  }

  parseLinkRef(links) {
    if (!links) {
      return;
    }

    return links.map(link => {
      return { ...link, linkPath: this.updateLinkRef(link.linkPath), dropdown: this.updateDropdownLinkRef(link) };
    });
  }

  parseStateForLinks() {
    const {
      links: { explore, plan, history, help, downloadApp, community, collections },
      user
    } = this.state;
    const links = [help, downloadApp];
    const dropdownLinks = this.props.featureFlags.communityFeatureFlag ? [explore, community, collections] : [explore, plan, history];

    return { links: this.parseLinkRef(links), dropdownLinks: this.parseLinkRef(dropdownLinks), user };
  }

  getMobileLinks() {
    // here we need to parse the links to have ?ref=mobile-header for tracking
    // parsing this on the client so the server doesn't need to generate a new routes
    const { links, dropdownLinks, user } = this.parseStateForLinks();

    if (user.dropdown.length > 0) {
      const myAccount = { label: StringConstantsMixin.strings.MY_ACCOUNT, linkPath: '#', dropdown: user.dropdown };
      dropdownLinks.push(myAccount);
    }

    return { dropdownLinks, links };
  }

  sideDrawerProps() {
    const { proButton, user } = this.state;
    const sideDrawerProps = this.getMobileLinks();
    return {
      ...sideDrawerProps,
      adminUser: this.props.adminUser,
      isOpen: this.state.isOpen,
      toggleIsOpen: wrapEventHandler(this.toggleIsOpen),
      proButton,
      user
    };
  }

  renderSideDrawer() {
    if (!this.state.isMounted) {
      return;
    }

    return (
      <Suspense fallback={null}>
        <SideDrawer {...this.sideDrawerProps()} />
      </Suspense>
    );
  }

  render() {
    if (this.state.slimMode) {
      return <div className={styles.mobileLeftSpacer} />;
    }

    return (
      <>
        <a href="#" onClick={wrapEventHandler(this.toggleIsOpen)} className={styles.navigationMenuLink} data-test-id="navigationDrawer-menuButton">
          <Menu className={styles.navigationMenu} />
        </a>
        {this.renderSideDrawer()}
      </>
    );
  }
}

NavigationDrawer.propTypes = {
  adminUser: bool, // can be logged out
  currentUser: object,
  displayMetric: bool.isRequired,
  forceProLogo: bool,
  languageRegionCode: string,
  mobileBrowser: bool.isRequired,
  tabletBrowser: bool.isRequired,
  proUser: bool, // can be logged out
  messagingChannel: object
};

NavigationDrawer.defaultProps = {
  adminUser: null,
  currentUser: null,
  languageRegionCode: 'en-US',
  forceProLogo: false,
  messagingChannel: postal.channel('navigation_messagingChannel'),
  proUser: null
};

export default NavigationDrawer;
